const apiPath = () => {
  const {
    location: { origin },
  } = window;
  return `${origin}/o-ring-selector/api`;
};

export default apiPath;
